<div class="centered-container" fxLayout="column" fxLayoutAlign="start center">
  <app-my-profile-incomplete></app-my-profile-incomplete>
  <app-promo-image-header></app-promo-image-header>
  <app-highlighted-services></app-highlighted-services>
</div>
